import React, { useEffect, useState } from 'react';
import TeamDialog from '../components/TeamDialog/TeamDialog';
import { IIndexable } from '../components/GraphicsLibrary/GraphicDetail/GraphicDetail';
import { useTypedSelector } from '../shared/hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import * as actions from '../store/actions';

interface Props {}

declare global {
    interface Window {
        openTeamDialog: any;
        GET_ID_PRODUCT_FCE_NAME: string;
        GET_IS_TEAM_FCE_NAME: string;
        GET_SAVED_TEAM_FCE_NAME: string;
    }
}

const TeamContainer: React.FC<Props> = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const { data: productData, loading: productLoading } = useTypedSelector(
        (state) => state.od.loadProduct
    );
    const { data: teamData } = useTypedSelector((state) => state.od.team);

    useEffect(() => {
        window.openTeamDialog = () => {
            setIsOpen(true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isOpen === false && teamData !== null) {
            (window as IIndexable)[window.SET_TEAM_FCE_NAME](teamData);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            if (productData === null && !productLoading) {
                const idProduct = (window as IIndexable)[
                    window.GET_ID_PRODUCT_FCE_NAME
                ]();
                const idLang = (window as IIndexable)[
                    window.GET_ID_LANGUAGE_FCE_NAME
                ]();
                const idCurrency = (window as IIndexable)[
                    window.GET_ID_CURRENCY_FCE_NAME
                ]();
                dispatch(actions.loadProduct(idProduct, idLang, idCurrency));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    return (
        <TeamDialog
            isOpen={isOpen}
            onClose={() => {
                setIsOpen(false);
            }}
        />
    );
};

export default TeamContainer;
